import { connect } from 'react-redux';
import { TextField, Button } from '@devfolioco/genesis';
import { withRouter } from 'react-router';
import { RECAPTCHA_KEY } from '@constants/environment';
import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import CaptchaPrivacyPolicy from 'components/CaptchaPrivacyPolicy';

import { clearAuthenticationErrors, signIn } from 'actions/authentication';
import { ERRORS } from '@constants/errors';
import { fetchUserBasicInfo } from 'actions/user';

class SignIn extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      _id: '',
      _password: '',
    };
    this.recaptchaRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const { isLoading, isAuthenticated } = this.props;

    if (isAuthenticated !== prevProps.isAuthenticated && isAuthenticated) {
      if (!isLoading) {
        this.fetchUserData();
      }
    }
  }

  fetchUserData = () => {
    const { dispatchFetchUserData } = this.props;
    dispatchFetchUserData();
  };

  handleInputChange = ({ target }) => {
    const { error, dispatchClearErrors } = this.props;
    const { name, value } = target;

    this.setState({ [name]: value });

    /**
     * > To clear the error messages that are currenly being displayed
     *   as soon as the _id or _password input is reset
     */
    if (error) {
      dispatchClearErrors();
    }
  };

  handleSubmit = captcha => {
    const { dispatchSignIn } = this.props;
    const { _id, _password, error } = this.state;
    if (!error) {
      dispatchSignIn(_id, _password, captcha, this.recaptchaRef);
    }
  };

  executeCaptcha = e => {
    e.preventDefault();
    this.recaptchaRef.current.execute();
  };

  render() {
    const { error, disabled, preFields, postFields, isLoading, userIsLoading } = this.props;

    return (
      <>
        <form onSubmit={this.executeCaptcha}>
          {preFields}

          <TextField
            autoFocus={!preFields}
            label="Username or Email"
            name="_id"
            onChange={this.handleInputChange}
            required
            spellCheck={false}
            type="text"
            error={{
              [ERRORS.emailNotFound]: error === ERRORS.emailNotFound,
              [ERRORS.usernameNotFound]: error === ERRORS.usernameNotFound,
            }}
          />

          <TextField
            label="Password"
            name="_password"
            onChange={this.handleInputChange}
            placeholder=""
            required
            spellCheck={false}
            type="password"
            error={{
              [ERRORS.passwordIncorrect]: error === ERRORS.passwordIncorrect,
              [ERRORS.passwordRateLimitExceeded]: error === ERRORS.passwordRateLimitExceeded,
              [ERRORS.loginFailed]: error === ERRORS.loginFailed,
            }}
          />

          {postFields}

          <Button
            type="submit"
            size="large"
            stretch
            disabled={disabled}
            style={{ marginTop: '1rem' }}
            loading={isLoading || userIsLoading}
          >
            Login and continue
          </Button>
        </form>
        <CaptchaPrivacyPolicy style={{ marginTop: 24 }} />
        <ReCAPTCHA ref={this.recaptchaRef} size="invisible" sitekey={RECAPTCHA_KEY} onChange={this.handleSubmit} />
      </>
    );
  }
}

const mapStateToProps = ({ user, authentication }) => ({
  error: authentication.error,
  isAuthenticated: authentication.isAuthenticated,
  isEmailVerified: user.isEmailVerified,
  isLoading: authentication.isLoading,
  userIsLoading: user.isLoading,
  username: authentication.username,
});

const mapDispatchToProps = dispatch => ({
  dispatchSignIn: (id, password, captcha, captchaRef) => {
    dispatch(signIn(id, password, captcha, captchaRef, false));
  },
  dispatchClearErrors: () => {
    dispatch(clearAuthenticationErrors());
  },
  dispatchFetchUserData: () => {
    dispatch(fetchUserBasicInfo());
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SignIn));
